import { useContext } from 'react';
import { GlobalState } from "./../../context/globalState";
import Images from "./../../asset/exportImages";
import { Row, Col, Button } from "antd";
import { trackProductEvent } from '../../lib/trackingService';

const Foodter = ({ btnText, showFees, disabled }) => {
  const { isMobile, setStep, step, dataOrder, loading, packages, Helper, dataFees, listOfInsuredPeople } = useContext(GlobalState);

  const handleBuyNow = () => {
    trackProductEvent("product_buy_now_click", {
      product_id: 93,
    });
    setStep(2);
  };

  return (
    <Row style={{ position: 'fixed', bottom: 0, width: '100%', left: 0, zIndex: 1000 }}>
      {
        (step === 1 && isMobile) &&
        <Col xl={24} xs={24}>
          <div style={{ padding: isMobile ? '0px 15px 15px 15px' : '0px 50px', borderRadius: isMobile ? '15px' : '0px', background: '#fff', boxShadow: "0px -2px 4px 0px #0000001A" }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%', height: isMobile ? 50 : 74, maxWidth: 900, margin: '0px auto', gap: 15, padding: isMobile ? "15px 0px" : 0, borderRadius: '15px' }}>
              <Button
                loading={loading}
                icon={<img src={Images.ICMuaNgay} width={'20px'} height={'20px'} style={{ marginBottom: -3 }} />}
                onClick={handleBuyNow}
                style={{ backgroundColor: '#009B4B', height: 44, width: isMobile ? '100%' : 165, fontWeight: 500, borderRadius: 8, color: '#fff' }}
                type="primary">
                Mua ngay
              </Button>
            </div>
          </div>
        </Col>
      }
      {
        (step === 1 && !isMobile) &&
        <Col xs={24} style={{ background: '#F0F2F5', position: 'fixed', bottom: 0, width: '100%', zIndex: 1000, padding: '15px 60px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: 60, maxWidth: 900, margin: '0px auto' }}>
            <Button
              loading={loading}
              icon={<img src={Images.ICMuaNgay} width={'20px'} height={'20px'} style={{ marginBottom: -3 }} />}
              onClick={handleBuyNow}
              style={{ backgroundColor: '#009B4B', height: 44, width: '100%', fontWeight: 500, borderRadius: 8, color: '#fff' }}
              type="primary">
              Mua ngay
            </Button>
          </div>
        </Col>
      }
      {
        step > 1 &&
        <Col xl={24} xs={24}>
          <div style={{ padding: isMobile ? '0px 15px 15px 15px' : '0px 50px', borderRadius: isMobile ? '15px' : '0px', background: '#fff', boxShadow: "0px -2px 4px 0px #0000001A" }}>
            {
              (showFees && isMobile) &&
              <>
                <div style={{ padding: '15px 0px 10px 0px', fontSize: 16, display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#646D69' }}>Số tiền thanh toán:</span>
                  <span style={{ color: '#FB7800', fontWeight: 600 }}>
                    {Helper.formatMoney(dataFees?.totalInsured || 0)} VNĐ
                  </span>
                </div>
                <div style={{ width: '100%', height: '0.5px', background: '#d2d2d2' }}></div>
              </>
            }

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: isMobile ? 50 : 74, margin: '0px auto', gap: 15, padding: isMobile ? "15px 0px" : 0, borderRadius: '15px' }}>
              {(!isMobile && (step > 1 && step < 4)) &&
                <div style={{ padding: '15px 0px 10px 0px', fontSize: 20, width: '100%' }}>
                  <span style={{ color: '#646D69', fontSize: 20 }}>Số tiền thanh toán: </span>
                  <span style={{ color: '#FB7800', fontWeight: 600, fontSize: 20 }}>
                    {Helper.formatMoney(dataFees?.totalInsured || 0)} VNĐ
                  </span>
                </div>
              }
              <div style={{ display: 'flex', gap: 15, width: '100%', justifyContent: 'flex-end' }}>
                <Button
                  onClick={() => setStep(step - 1)}
                  icon={<img src={Images.ICBack} width={8} height={10} />}
                  style={{ backgroundColor: '#F0F2F5', height: 44, width: isMobile ? '100%' : 165, color: '#343A40', fontWeight: 500, border: '0.5px solid #d9d9d9', boxShadow: 'none', borderRadius: 8 }}
                  type="primary">
                  Quay lại
                </Button>
                <Button
                  // disabled={disabled}
                  loading={loading}
                  htmlType='submit'
                  style={{
                    backgroundColor: '#009B4B',
                    // backgroundColor: disabled ? '#969696' : '#009B4B',
                    height: 44, width: isMobile ? '100%' : 165,
                    fontWeight: 500, boxShadow: 'none',
                    borderRadius: 8,
                    color: '#fff'
                  }}
                  type="primary"
                >
                  {btnText || 'Tiếp tục'}
                </Button>
              </div>

            </div>
          </div>
        </Col>
      }

    </Row>
  );
}

export default Foodter;